
import { Vue, Component } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import axios from "axios";
@Component
export default class Home extends Vue {
  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 15,
    },
    className: "warehouse",
  });

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Склады",
        disabled: true,
      },
    ];
  }

  headers =[
    {
      "text": "ID",
      "value": "id",
      "sortable": true
    },
    {
      "text": "Дата создания",
      "value": "createDate",
      "sortable": true
    },
    {
      "text": "Подпись",
      "value": "caption",
      "sortable": true
    },
    {
      "text": "По умолчанию",
      "value": "isDefault",
    },
    {
      "text": "Статус",
      "value": "instanceStateId",
      "sortable": false
    }
  ]


  async setDefault(item: any) {
    await axios
      .put(`/manage/warehouse/set-default/${item.id}/`)
    await this.dataSource.get();
  }
}
